import { render } from "./ReportesFiltros_sap.vue?vue&type=template&id=1021ba4d&bindings={\"breadcrumbA\":\"data\",\"breadcrumbB\":\"data\",\"descripcion\":\"data\",\"triggers\":\"data\",\"personal\":\"data\",\"obtenerPersonal\":\"options\",\"refrescarPersonal\":\"options\"}"
import script from "./ReportesFiltros_sap.vue?vue&type=script&lang=js"
export * from "./ReportesFiltros_sap.vue?vue&type=script&lang=js"

import "./ReportesFiltros_sap.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script